import $ from "jquery";
window.jQuery = $;
window.$ = $;
import select2 from "select2";
import TomSelect from "tom-select";

require("jquery-accessible-subnav-dropdown/jquery-accessible-subnav-dropdown.js");
require("magnific-popup/dist/jquery.magnific-popup");

$.extend($.expr[':'], {
  'containsi': function(elem, i, match, array)
  {
    return (elem.textContent || elem.innerText || '').toLowerCase()
    .indexOf((match[3] || "").toLowerCase()) >= 0;
  }
});

$(function() {
    $('.video-link').magnificPopup({type:'iframe'});
    $(".topic form select").select2({
        formatNoMatches: function() {
            return 'Keine Themen gefunden';
        },
    }).on("select2:open", function() {
        $("body").addClass("in-app--topics-open")
    }).on("select2:close", function() {
        $("body").removeClass("in-app--topics-open")
    });
    // const sel = new TomSelect('.topic form select',{
    //     sortField: {
    //         field: "text",
    //         direction: "asc"
    //     }
    //
    //     // onChange: () => {
    //     //     setTimeout(() => {
    //     //         $(window).scrollTop(0);
    //     //     }, 300)
    //     // }
    // });

    // sel.on('focus', () => {
    //     $("body").addClass("in-app--topics-open")
    // })
    // sel.on('blur', () => {
    //     $("body").removeClass("in-app--topics-open")
    // })

    // $("#cat-filter").select2();
    $("#cat-filter").change(function() {
        // console.log($("#resourceform"));
        // console.log(this.form);
        this.form.submit();
        // $("#resourceform").submit();
    })
    $(".showhide .showhide-head").click(function() {
        $(".boxcontent", $(this).parent()).slideToggle("normal", function() {
            $(this).parent().toggleClass("showhide-open");
        });
    });
    $(".resource_head").click(function() {
        $(this).parent().toggleClass("resource--open");
    });
    $("#menu-login a").click(function() {
        $("#login").fadeToggle();
        return false;
    });

    $("#mainnav-toggle").click(function() {
        $("body").toggleClass("nav--open");
    })

});

var cat = 0;
var search = "";

$(function() {
    $("#topic-search input#q").keyup(function() {
        search = this.value;
        searchTopics();
    });

    $("#topicselection").on("change", function(e) {
        cat = e.currentTarget.value;
        // console.log(e.currentTarget.value);
        searchTopics();
    });

    $(".topic_group_head").on("click", function(e) {
        $(this).parent().toggleClass("topic_group--open");
        $(".topic_group").not($(this).parent()).removeClass("topic_group--open");
    });

    // $(".catlist a").click(function() {
    //  //$(".cathead").html(this.html());
    //  selectCat($(this).data("cat"), $(this).html());
    //  hideCats();
    //  searchTopics();
    //  return false;
    // });

    // $(".cathead").click(function() {
    //  showhideCats();
    //  return false;
    // });
    $(".secret .switch").click(function() {
       $(this).siblings(".secret-text").toggleClass("secret-text--show");
    });
    $(".moreinfo .switch").click(function() {
        $(this).siblings(".info").fadeToggle();
        $(this).hide();
    });
});

function searchTopics() {
    if((cat === 0 || cat === "0" || cat === "") && search === "") {
        $(".topic-results li").show();
    } else {
        // console.log(cat);
        var results = $(".topic-results li").hide();
        if(cat !== 0 && cat !== "" && cat != "0")
            results = results.filter('[data-topics*="|'+cat+'|"]');
        if(search !== "") {
            results = results.filter(":containsi('"+search+"')");
        }

        results.show();

        $(".topic-results").show();
    }
}

function showCats() {
    $(".catlist:hidden").slideDown();
    $(".catlist").parent().addClass("catlist-open");
}

function hideCats() {
    $(".catlist:visible").slideUp();
    $(".catlist").parent().removeClass("catlist-open");
}

function showhideCats() {
    $(".catlist").slideToggle();
    $(".catlist").parent().toggleClass("catlist-open");
}

function selectCat(id, name) {
    cat = id;
    $(".cathead").html(name);
}
